module.exports = __webpack_public_path__ + "static/media/NoResults.fa96f679.svg";